
<div class="float-right status-filter-btn-container">
    <button type="button" class="pr-btn-filter" [ngClass]="{'activated' : isFilterVisible || isStatusFilterActive()}"
            (click)="onOpenFilterModalBtnClicked()">
        <bd-fa [name]="'filter'"></bd-fa>
        Statusfilter
    </button>
    <app-project-filter class="status-filter" (filterBtnClicked)="onFilterModalBtnClicked($event)"
                        [filterModel]="filterDialogModel"
                        *ngIf="isFilterVisible"
                        #filterModal>
    </app-project-filter>
</div>

<app-projects-table [projects]="projects"
                    (headerSortBtnClicked)="onTableSortBtnClicked( $event )"
                    (projectTableRowActionsMenuClicked)="onProjectTableRowActionsMenuClicked( $event )">

</app-projects-table>

